import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ta-type-autocomplete-dropdown',
    templateUrl: './ta-type-autocomplete-dropdown.component.html',
    styleUrls: ['./ta-type-autocomplete-dropdown.component.scss'],
})
export class TaTypeAutocompleteDropdownComponent {
    @Input() callbackData: any;
    // defaultIndex: any;

    // ngOnInit() {
    //     this.defaultIndex = this.callbackData[0].arg[1].options.findIndex((data: any) => {
    //         console.log(data.value);

    //         return data.value == this.callbackData[0].arg[0];
    //         // console.log(this.callbackData[0].arg[0]);
    //     });
    //     console.log(this.defaultIndex);
    // }

    selectedItem(event: any) {
        if (this.callbackData && this.callbackData[0] && this.callbackData[0].callback) {
            this.callbackData[0].callback(event.data, this.callbackData[0].arg[2], this.callbackData[0].arg[3]);
        }
    }
}
